import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Pagination, Skeleton, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
import dayjs from 'dayjs'
import SaleContext from './services/saleApi'
import { MobileDatePicker } from '@mui/x-date-pickers'
const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function Promotion() {
    const { getPromotionList } = useContext(SaleContext)
    const [data, setData] = useState([])
    const [promotionNo, setPromotionNo] = useState('')
    const [sdate, setSdate] = useState(null)
    const [edate, setEdate] = useState(null)
    const [loading, setLoading] = useState(false);
    // const [page, setPage] = React.useState(1);
    const [searchParams, setSearchParams] = useSearchParams()
    let p = searchParams.get('p') || ''
    let s = searchParams.get('s') || ''
    let e = searchParams.get('e') || ''
    let id = searchParams.get('id') || ''
    let page = searchParams.get('page') || '1'
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleSearch = async (e) => {
        e.preventDefault()
        setSearchParams({ p: promotionNo, s: sdate ? dayjs(sdate).format('YYYY-MM-DD') : '', e: edate ? dayjs(edate).format('YYYY-MM-DD') : '' })

    }
    useEffect(() => {
        getPromotionList(p, s, e, setData)
    }, [p, s, e])
    useEffect(() => {
        if(data.length > 0){
            setLoading(false)
        }else{
            setLoading(true)
        }
    },[data])
    return (
        <div>
            <Page>
                <form onSubmit={e => handleSearch(e)}>
                    <div class="container-fluid">
                        <div class="row mt-3">
                            <div class="col-md-4">
                                <Box className='backgroundField'>
                                    <TextField value={promotionNo} onChange={e => setPromotionNo(e.target.value)} variant="standard" fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                                        InputProps={{
                                            disableUnderline: true,
                                            startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-md-3">
                                <Box className='backgroundField'>

                                    <MobileDatePicker
                                        dayOfWeekFormatter={(day) => `${day}`}
                                        value={sdate} onChange={e => setSdate(e)}
                                        slotProps={{ textField: { variant: 'standard', placeholder: 'วันที่เริ่มต้น', fullWidth: true, InputProps: { disableUnderline: true }, value: sdate } }}
                                        slots={{
                                            textField: BrowserInput,
                                        }}
                                    />

                                </Box>
                            </div>
                            <div class="col-md-3">
                                <Box className='backgroundField'>
                                    <MobileDatePicker
                                        dayOfWeekFormatter={(day) => `${day}`}
                                        value={edate} onChange={e => setEdate(e)}
                                        slotProps={{ textField: { variant: 'standard', placeholder: 'วันที่สิ้นสุด', fullWidth: true, InputProps: { disableUnderline: true }, value: edate } }}
                                        slots={{
                                            textField: BrowserInput,
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-md-2">

                                <Button className='ButtomSearch' type='submit' variant='contained'>ค้นหา</Button>
                            </div>
                        </div>
                    </div>
                </form >
            </Page >
            <Page>
                <div class="container-fluid">
                    <div class=" d-flex row justify-content-between align-items-baseline">
                        <div class="col-lg-5 col-md-12 text-left ">
                            <label class="title-content mb-4">
                                รายการราคาขายเฉพาะกิจ
                            </label>
                        </div>
                        <div class="col-lg-3 col-md-12 text-end px-4">
                            <Link to='/sale/promotion/add'>
                                <Button type="button" className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                            </Link>
                        </div>

                    </div>

                    <div class="listData row">
                    {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                        <div class="col-md-12 table-responsive-sm pb-3">
                            <table class="table table-borderless ">
                                <thead>
                                    <tr>
                                        <th class="text-center">ที่</th>
                                        <th class="text-center">วันที่</th>
                                        <th class="text-center">เลขที่เอกสาร</th>
                                        <th class="text-center">ชื่อโครงการ</th>
                                        <th class="text-center">วันที่เริ่ม</th>
                                        <th class="text-center">วันที่สิ้นสุด</th>
                                        <th class="text-center">สถานะ</th>
                                        <th class="text-center">ดำเนินการ</th>
                                    </tr>
                                </thead>
                                <tbody class="">
                                    {data?.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)?.map((x, i) => (
                                        <tr className={id === x?.PromotionNo ? 'active' : ''}>
                                            <td class="text-center">{(page - 1) * rowsPerPage + i + 1}</td>
                                            <td class="text-center">{dayjs(x?.DocumentDate).format('DD/MM/BBBB')}</td>
                                            <td class="text-center">{x?.RefNo}</td>
                                            <td class="text-center">{x?.CampaignName}</td>
                                            <td class="text-center">{dayjs(x?.StartDate).format('DD/MM/BBBB')}</td>
                                            <td class="text-center">{dayjs(x?.EndDate).format('DD/MM/BBBB')}</td>
                                            <td class="text-center">
                                                {x.Status === 'Y' ?
                                                    <span class="status-active">
                                                        ใช้งาน
                                                    </span> : <span class="status-inactive">
                                                        ยกเลิก
                                                    </span>}
                                            </td>
                                            <td class="text-center">
                                                <Link to={`/sale/promotion/${x?.PromotionNo}`} onClick={() => setSearchParams({ id: x?.PromotionNo, page: page, p: p, s: s, e: e })}>
                                                    <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
                                                </Link>
                                            </td>
                                        </tr >
                                    ))}

                                </tbody >
                            </table >
                        </div >}
                        <div class="col-md-12 text-center mt-4">
                            <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={Math.ceil(data.length / rowsPerPage)} page={+page} onChange={(event, value) => setSearchParams({ page: value, p: p, s: s, e: e, id: id })} shape="rounded" />

                        </div >
                    </div >
                </div >
            </Page >
        </div >
    )
}
